import { type ExamCenter } from '@exam-center/graphql';

export function mapExamCenterDetailsDefaultFormValues(
  examCenter: Pick<
    ExamCenter,
    | 'nameTH'
    | 'nameEN'
    | 'addressTH'
    | 'addressEN'
    | 'phoneTH'
    | 'phoneEN'
    | 'email'
    | 'examResultRecipientEmail'
    | 'website'
  >,
) {
  return {
    nameTH: examCenter.nameTH,
    addressTH: examCenter.addressTH ?? '',
    phoneTH: examCenter.phoneTH ?? '',
    nameEN: examCenter.nameEN,
    addressEN: examCenter.addressEN ?? '',
    phoneEN: examCenter.phoneEN ?? '',
    website: examCenter.website ?? '',
    email: examCenter.email ?? '',
    examResultRecipientEmail: examCenter.examResultRecipientEmail ?? '',
  };
}
